module.exports = __webpack_public_path__ + "img/bb6.df3f475b.jpg";